<template>
  <a-modal
    title="竞价参数"
    :width="720"
    :visible="visible"
    :destroyOnClose="true"
    :maskClosable="false"
    :confirmLoading="saving"
    @cancel="handleClose"
  >
    <div class="bid-param-content">
      <a-alert
        message="租赁平台确认竞价参数后相关信息不可更改。"
        type="error"
        show-icon
        class="bid-param-alert"
      />
      <a-spin :spinning="loading">
        <a-form-model
          ref="formRef"
          :model="form"
          :rules="rules"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-form-model-item label="报价开始时间" prop="quoteStartTime">
            <a-date-picker
              v-model="form.quoteStartTime"
              :show-time="{ format: 'HH:mm' }"
              format="YYYY-MM-DD HH:mm"
              valueFormat="YYYY-MM-DD HH:mm"
              placeholder="请选择报价开始时间"
              style="width: 100%"
            />
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </div>
    <template slot="footer">
      <a-button :disabled="saving" @click="handleClose">关闭</a-button>
      <a-button type="primary" :loading="saving" @click="handleSave">
        确定
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import {
  getBidProjectBiddingParam,
  saveBidProjectBiddingParam,
} from "@/api/project/Project.js";

export default {
  name: "BidParamModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      saving: false,
      form: {
        quoteStartTime: undefined,
      },
      rules: {
        quoteStartTime: [
          {
            required: true,
            message: "请选择报价开始时间",
            trigger: "change",
          },
        ],
      },
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.form.quoteStartTime = undefined;
        this.getDetail();
      }
    },
  },
  methods: {
    getDetail() {
      const webId = (this.record || {}).webId;
      if (!webId) return;

      this.loading = true;
      getBidProjectBiddingParam({ webId })
        .then((res) => {
          const data = res.data || {};
          this.form.quoteStartTime = this.normalizeMinuteTime(data.quoteStartTime);
        })
        .catch((err) => {
          this.$notification["error"]({
            message: "竞价参数查询失败",
            description: this.getErrorMessage(err),
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleClose() {
      if (this.saving) return;
      this.form.quoteStartTime = undefined;
      this.$emit("close");
    },

    handleSave() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        const webId = (this.record || {}).webId;
        if (!webId) return;

        this.saving = true;
        saveBidProjectBiddingParam({
          webId,
          quoteStartTime: this.form.quoteStartTime,
        })
          .then(() => {
            this.$message.success("竞价参数保存成功");
            this.form.quoteStartTime = undefined;
            this.$emit("saved");
          })
          .catch((err) => {
            this.$notification["error"]({
              message: "竞价参数保存失败",
              description: this.getErrorMessage(err),
            });
          })
          .finally(() => {
            this.saving = false;
          });
      });
    },

    normalizeMinuteTime(value) {
      if (!value) return undefined;
      return String(value).slice(0, 16);
    },

    getErrorMessage(err) {
      return (
        ((err.response || {}).data || {}).msg ||
        ((err.response || {}).data || {}).message ||
        err.msg ||
        err.message ||
        "网络异常，请稍后再试"
      );
    },
  },
};
</script>

<style scoped>
.bid-param-content {
  padding: 24px 16px 8px;
}

.bid-param-alert {
  margin-bottom: 30px;
}
</style>
